import { HttpErrorResponse } from '@angular/common/http';

export class PaymentRequiredError extends Error {
    httpStatus = 402;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, PaymentRequiredError.prototype);
    }
}
